import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterMd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.9999 20.35C10.6165 20.35 10.2957 20.2208 10.0374 19.9625C9.77903 19.7042 9.64986 19.3833 9.64986 19V13.125L3.74986 5.575C3.43319 5.175 3.38736 4.75 3.61236 4.3C3.83736 3.85 4.19986 3.625 4.69986 3.625H19.2999C19.7999 3.625 20.1624 3.85 20.3874 4.3C20.6124 4.75 20.5665 5.175 20.2499 5.575L14.3749 13.125V19.125C14.3749 19.475 14.254 19.7667 14.0124 20C13.7707 20.2333 13.4749 20.35 13.1249 20.35H10.9999ZM11.9999 12.9L17.7249 5.625H6.27486L11.9999 12.9Z",
		fill: "#3C59F6"
	})
});
export default SvgFilterMd;
